<section class="results-table">
  <table class="results-table__table">
    <tbody>
      @for (item of data; track item.token) {
        <tr>
          <td>Token {{ item.token }}</td>
          <td class="acciones">
            @for (guideId of item.cuestionario; track guideId) {
              <button class="btn--primary" (click)="onView(item, guideId)">
                {{ transformGuideId(guideId) }}
              </button>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
